import { HttpService, Messages, ServiceEndpoints } from '@/config/NextImport'
import { decryptData, encryptData } from '@/constants/Common'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { v4 as uuidv4 } from 'uuid'
import Cookies from 'js-cookie'

const initialState: {
  message: string
  cartListProducts: any
  status: boolean
  loading: boolean
} = {
  message: '',
  cartListProducts: {},
  status: false,
  loading: true
}

export const addToCart = createAsyncThunk(
  'cart/addToCart',
  async ({ item, ringSizeId, user, country = null, standaloneOptions = null }: any) => {
    const obj = {
      setting_sku: '',
      diamond_sku: '',
      id: uuidv4()
    }

    if (item.is_diamond === 1) {
      obj.diamond_sku = item.sku
    } else if (item.is_diamond === 0) {
      obj.setting_sku = item.sku
    } else {
      obj.diamond_sku = item.diamond_sku
      obj.setting_sku = item.setting_sku
    }
    const param = {
      setting_sku: obj.setting_sku,
      diamond_sku: obj.diamond_sku,
      customer_id: user !== undefined && user !== null ? user.id : '',
      size_id: ringSizeId !== undefined && ringSizeId.length !== 0 ? ringSizeId : 0,
      size_country: country,
      qty: item.qty !== undefined && item.qty !== null && item.qty !== '' ? item.qty : 1,
      standalone_options: standaloneOptions
    }

    const param2 = {
      setting_sku: obj.setting_sku,
      diamond_sku: obj.diamond_sku,
      uuid: Cookies.get(Messages.uuid),
      size_id: ringSizeId !== undefined && ringSizeId.length !== 0 ? ringSizeId : 0,
      size_country: country,
      qty: item.qty !== undefined && item.qty !== null && item.qty !== '' ? item.qty : 1,
      standalone_options: standaloneOptions
    }
    if (user !== undefined && user !== null) {
      const response = await HttpService.postApi(ServiceEndpoints.storeCartProducts, param)
      return response?.result[0] || null
    } else {
      const response = await HttpService.postApi(ServiceEndpoints.storeGuestCartData, param2)
      return response?.result || null
    }
  }
)
export const getCartProducts = createAsyncThunk('cart/getCartProducts', async (_, thunkAPI) => {
  const cartProducts = JSON.parse(decryptData(localStorage.getItem(Messages.CartProducts) || '[]')!)
  const { cart }: any = thunkAPI.getState()

  const param = {
    products: cartProducts,
    promo_code: localStorage.getItem(Messages.PromoCode),
    shipping_charge: parseFloat(cart.cartListProducts?.shipping_charge) ?? null,
    shipping_method: cart.cartListProducts?.shipping_method ?? '',
    shipping_postal_code: cart.cartListProducts?.shipping_postal_code ?? '',
    shipping_country: cart.cartListProducts?.shipping_country ?? '',
    shipping_methods: cart.cartListProducts?.shipping_methods ?? []
  }

  try {
    const response = await HttpService.postApi(ServiceEndpoints.getCartSubtotal, param)
    if (response?.result) {
      return response?.result
    }
  } catch (error) {
    console.log(error)
  }
})

export const getCustomerCartItem = createAsyncThunk(
  'cart/getCustomerCartItem',
  async (user: any) => {
    const param = {
      customer_id: user?.id
    }

    const response = await HttpService.postApi(ServiceEndpoints.getCustomerCartItem, param)
    return response?.result[0] || null
  }
)

export const removeCartItem = createAsyncThunk(
  'cart/removeCartItem',
  async ({ item, user }: any) => {
    const obj = {
      setting_sku: '',
      diamond_sku: '',
      id: ''
    }

    if (item[0]?.is_diamond === 1) {
      obj.diamond_sku = item[0].sku
    } else if (item[1]?.is_diamond === 1) {
      obj.diamond_sku = item[1].sku
    }

    if (item[0]?.is_diamond === 0) {
      obj.setting_sku = item[0].sku
    } else if (item[1]?.is_diamond === 0) {
      obj.setting_sku = item[1].sku
    }

    obj.id = user?.id || Cookies.get(Messages.uuid)

    const param = {
      customer_id: obj.id,
      setting_sku: obj.setting_sku,
      diamond_sku: obj.diamond_sku
    }

    const param1 = {
      setting_sku: obj.setting_sku,
      diamond_sku: obj.diamond_sku,
      uuid: obj.id
    }

    if (user) {
      const response = await HttpService.postApi(ServiceEndpoints.deleteCartProduct, param)
      return response?.result || null
    } else {
      const response = await HttpService.postApi(ServiceEndpoints.removeGuestCartData, param1)
      return response?.result || null
    }
  }
)

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCartListProducts: (state, action) => {
      const fields = action.payload

      for (const [key, value] of Object.entries(fields)) {
        state.cartListProducts[key] = value
      }
    },
    clearCart: (state) => {
      localStorage.removeItem(Messages.CartProducts)
      state.cartListProducts = {}
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addToCart.fulfilled, (state, action) => {
        if (action.payload) {
          localStorage.setItem(Messages.CartProducts, encryptData(JSON.stringify(action.payload)))
        }
      })
      // .addCase(getCartProducts.pending, (state) => {
      //   state.loading = true
      // })
      .addCase(getCartProducts.fulfilled, (state, action) => {
        state.loading = false
        state.cartListProducts = action.payload
      })
      .addCase(getCartProducts.rejected, (state) => {
        state.loading = false
      })
      .addCase(getCustomerCartItem.fulfilled, (state, action) => {
        if (action.payload) {
          localStorage.setItem(Messages.CartProducts, encryptData(JSON.stringify(action.payload)))
        }
      })
      .addCase(removeCartItem.fulfilled, (state, action) => {
        localStorage.setItem(Messages.CartProducts, encryptData(JSON.stringify(action.payload)))
      })
  }
})

export const { setCartListProducts, clearCart } = cartSlice.actions
export default cartSlice.reducer
